import { speedingsQueryKeys } from "./queryKeys"
import { useSpeedingsQuery } from "./useSpeedingsQueries"

export function useSpeedingsGrades(params = {}) {
    const url = "speeds/stats/average_exceed_5pct/"
    const queryKey = speedingsQueryKeys.grades(params)

    return useSpeedingsQuery(
        url,
        queryKey,
        params,
    )
}